import type { RouteRecordRaw } from "vue-router";
import ContactConversationsPage from "./ContactConversationsPage.vue";
import ContactEmailConfirmationPage from "./ContactEmailConfirmationPage.vue";
import ContactLayout from "./ContactLayout.vue";
import ContactPhoneNumberConfirmationPage from "./ContactPhoneNumberConfirmationPage.vue";
import ContactsPage from "./ContactsPage.vue";
import EditContactPage from "./EditContactPage.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/contacts",
    children: [
      {
        path: "",
        name: "contacts",
        component: ContactsPage,
      },
      {
        path: "/contacts/:id",
        name: "contact",
        component: ContactLayout,
        props: (route) => ({ id: route.params.id }),
        children: [
          {
            path: "",
            name: "editContact",
            component: EditContactPage,
          },
          {
            path: "conversations",
            name: "contactConversations",
            component: ContactConversationsPage,
          },
        ],
      },
    ],
  },
  {
    path: "/c/e/:token",
    name: "contactEmailConfirmation",
    component: ContactEmailConfirmationPage,
    props: true,
  },
  {
    path: "/c/p/:token",
    name: "contactPhoneNumberConfirmation",
    component: ContactPhoneNumberConfirmationPage,
    props: true,
  },
];

export default routes;
